import dynamic from 'next/dynamic';

const ProcurementOrdersListContent = dynamic(() =>
  import('./ProcurementOrdersListContent')
);

const AddProcurementOrderModal = dynamic(() =>
  import('./AddProcurementOrderModal')
);

const ProcurementOrderForm = dynamic(() =>
  import('./ProcurementOrderForm/ProcurementOrderForm')
);

const ProcurementOrderContent = dynamic(() =>
  import('./ProcurementOrderContent/ProcurementOrderContent')
);

const ProcurementOrderDetails = dynamic(() =>
  import('./ProcurementOrderDetails/ProcurementOrderDetails')
);

const ProcurementOrderPricingDetails = dynamic(() =>
  import('./ProcurementOrderPricingDetails/ProcurementOrderPricingDetails')
);

export {
  ProcurementOrdersListContent,
  AddProcurementOrderModal,
  ProcurementOrderForm,
  ProcurementOrderContent,
  ProcurementOrderDetails,
  ProcurementOrderPricingDetails,
};
